
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import GenericPMSTableMenu from "./GenericPMSTableMenu.vue";
import SortableTable, { SortableTableHeader } from "./SortableTableDirective";
import { VDataTable } from "vuetify/lib";
import { DataOptions } from "vuetify";
import ResizableTable from "./ResizableTableDirective";
import _ from "lodash";

@Component({
  components: {
    GenericPMSTableMenu,
    VDataTable,
  },
  directives: {
    SortableTable,
    ResizableTable,
  },
})
export default class SortableHeadersTable extends Vue {
  @Prop()
  headers?: SortableTableHeader[];
  @Prop()
  items?: any[];
  @Prop({ default: null })
  expandedRow?: SortableTableHeader | null;

  @Prop() options?: DataOptions;
  @Prop() tableName?: string;
  @Prop({ default: false }) settingsOpen?: boolean;

  @Prop({ default: true })
  translateHeaders?: boolean;

  key = 0;

  get activeHeaders() {
    if (!this.headers) {
      return [];
    }

    if (this.translateHeaders) {
      return [
        ...this.headers
          .filter((x) => x.active)
          .map((x) => ({ ...x, text: this.$t(x.text) })),
      ];
    } else {
      return [...this.headers.filter((x) => x.active)];
    }
  }

  sortTheHeaders(evt: any) {
    if (!this.headers) {
      return;
    }

    const headersTmp = _.cloneDeep(this.headers);

    const originItem = headersTmp.filter((x) => x.active)[evt.oldIndex];
    const targetItem = headersTmp.filter((x) => x.active)[evt.newIndex];

    const originIndex = headersTmp.indexOf(originItem);
    const targetIndex = headersTmp.indexOf(targetItem);

    headersTmp.splice(targetIndex, 0, headersTmp.splice(originIndex, 1)[0]);

    this.$emit("update:headers", headersTmp);
  }

  @Watch("headers", { deep: true })
  headersWatch(fresh: any[], old: any[]) {
    if (fresh && old && !_.isEqual(fresh, old)) {
      this.key++;
    }
  }

  get genericPMSTableMenuListeners() {
    const toReturn: any = {};

    toReturn["update:open"] = ($event: any) =>
      this.$emit("update:settingsOpen", $event);
    toReturn["update:columns"] = this.$listeners["update:headers"];
    if (this.expandedRow) {
      toReturn["update:expandedRow"] = this.$listeners["update:expandedRow"];
    }

    toReturn["update:options"] = this.$listeners["update:options"];
    toReturn["loaded:settings"] = () => this.$emit("loaded");

    if (this.$listeners["menu:excel"] != undefined) {
      toReturn["menu:excel"] = this.$listeners["menu:excel"];
    }

    return toReturn;
  }

  render() {
    return this.$createElement(
      "div",
      {
        class: "sortable-headers-table-wrapper",
      },
      [
        this.$createElement("GenericPMSTableMenu", {
          props: {
            columns: this.headers,
            tableName: this.tableName,
            expandedRow: this.expandedRow,
            open: this.settingsOpen,
            options: this.options,
            hasExportToExcel: this.$listeners["menu:excel"] != undefined,
          },
          on: {
            ...this.genericPMSTableMenuListeners,
          },
        }),
        this.$createElement("v-data-table", {
          props: {
            ...this.$attrs,
            ...this.$props,
            items: this.items,
            headers: this.activeHeaders,
          },
          on: {
            ...this.$listeners,
          },
          directives: [
            {
              name: "sortable-table",
              value: { onEnd: this.sortTheHeaders },
            },
            {
              name: "resizable-table",
              value: { headers: this.headers },
            },
          ],
          scopedSlots: {
            ...this.$scopedSlots,
          },
          key: this.key,
          ref: "dataTable",
          class: "resizable-table",
        }),
      ]
    );
  }
  @Watch("items")
  scrollToTop() {
    let scrollableWrapper: Element | null = null;

    if (this.$refs.dataTable instanceof Vue) {
      scrollableWrapper = (this.$refs.dataTable as Vue).$el.querySelector(
        ".v-data-table__wrapper"
      );
    } else if (this.$refs.dataTable instanceof Element) {
      scrollableWrapper = (this.$refs.dataTable as Element).querySelector(
        ".v-data-table__wrapper"
      );
    }

    if (scrollableWrapper) {
      scrollableWrapper.scrollTop = 0;
    }
  }
}
